import Vue from 'vue';

import List from 'vant/lib/list';
import CellGroup from 'vant/lib/cell-group';
import Cell from 'vant/lib/cell';
import Icon from 'vant/lib/icon';
import Tag from 'vant/lib/tag';
import Popup from 'vant/lib/popup';
import Button from 'vant/lib/button';
import Loading from 'vant/lib/loading';
import DropdownMenu from 'vant/lib/dropdown-menu';
import DropdownItem from 'vant/lib/dropdown-item';
import Search from 'vant/lib/search';
import Field from 'vant/lib/field';
import Form from 'vant/lib/form';
import Picker from 'vant/lib/picker';
import Checkbox from 'vant/lib/checkbox';
import Swipe from 'vant/lib/swipe';
import SwipeItem from 'vant/lib/swipe-item';
import 'vant/lib/list/style';
import 'vant/lib/cell-group/style';
import 'vant/lib/cell/style';
import 'vant/lib/tag/style';
import 'vant/lib/popup/style';
import 'vant/lib/button/style';
import 'vant/lib/loading/style';
import 'vant/lib/dropdown-menu/style';
import 'vant/lib/dropdown-item/style';
import 'vant/lib/search/style';
import 'vant/lib/field/style';
import 'vant/lib/form/style';
import 'vant/lib/picker/style';
import 'vant/lib/checkbox/style';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';

import CommonHeader from '@/components/CommonHeader';
import LongList from '@/components/LongList';
import TipModal from '@/components/TipModal';

Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(Search.name, Search);
Vue.component(Field.name, Field);
Vue.component(Form.name, Form);
Vue.component(Picker.name, Picker);
Vue.component(Checkbox.name, Checkbox);
Vue.component(List.name, List);
Vue.component(CellGroup.name, CellGroup);
Vue.component(Cell.name, Cell);
Vue.component(Icon.name, Icon);
Vue.component(Tag.name, Tag);
Vue.component(Popup.name, Popup);
Vue.component(Button.name, Button);
Vue.component(Loading.name, Loading);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

Vue.component(CommonHeader.name, CommonHeader);
Vue.component(LongList.name, LongList);
Vue.component(TipModal.name, TipModal);
